export const CHANGE_STATE = 'CHANGE_STATE'